/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import { useRef, useState, useMemo, useCallback, useEffect } from 'react'
import {
  useActions,
  useConnectedState,
  useSlicedData,
  useTiles,
  useZoomBehavior,
} from './hooks'
import { MapZoomControls, Group, Leaf } from './components'
import styles from './styles.module.scss'
import 'src/core/autoupdater'
import {
  addWatchListItem,
  deleteWatchListItem,
  getWatchlistTabs,
} from 'src/redux/thunks'
import { useDispatch } from 'react-redux'
import { useRouter } from 'next/router'

export const TreeMap = props => {
  const canvas = useRef(null)
  const ref = useRef(null)
  const dispatch = useDispatch()
  const router = useRouter()
  const isShare = router.asPath.includes('getScreen')

  useEffect(() => {
    window['grid_params'] = []
    window.autoUpdater.start()
    return () => {
      window.autoUpdater.stop()
    }
  }, [])

  const [handlers, setHandlers] = useState({
    onStart: () => {},
    onEnd: () => {},
  })

  const isServer = false
  const { setGroup } = useActions()

  const addWatchListItems = slug => dispatch(addWatchListItem(slug))
  const deleteWatchListItems = slug => dispatch(deleteWatchListItem(slug))
  const pushToast = () => console.log('=> pushToast')

  const zoom = useZoomBehavior({
    ref,
    isServer,
    props: {
      ...props,
      disableZoom: props.isMobile || props.disableZoom, // Combine mobile and manual toggle
    },
    handlers,
  })

  /* eslint-disable react-hooks/rules-of-hooks */
  /* Sorry :( I know that I can't use hooks conditionally, but to avoid huge refactor
   * and not impact tree performance I am ommiting useConnectedState. It doesn't
   * cause any problem if the conditonal use never change
   */
  const state = props.state || useConnectedState({ props })
  /* eslint-enable react-hooks/rules-of-hooks */

  // useEffect(() => {
  //   if (state.data.leaves.length > 0) {
  //     dispatch(getWatchlistTabs())
  //   }
  // }, [dispatch, state])

  const sliced = useSlicedData({
    data: state.data,
    transform: zoom.transform,
    width: props.width,
    height: props.height,
  })

  const cssTransform = useMemo(
    () =>
      sliced.locked
        ? `translate3d(${sliced.diff.x}px, ${sliced.diff.y}px, 0) scale(${sliced.diff.k})`
        : undefined,
    [sliced.locked, sliced.diff]
  )

  const { highlight } = useTiles({
    ref: canvas,
    transform: zoom.transform,
    groups: state.data ? state.data.groups : [],
    leaves: state.data ? state.data.leaves : [],
    width: props.width,
    height: props.height,
    globalSearchSymbol: state.globalSearchSymbol,
    baseValue: props.baseValue,
    entity: props.entity,
  })

  const onGroupClick = useCallback(
    group => {
      setGroup(props.groupFilter === group.data.name ? 'all' : group.data.name)
    },
    [props.groupFilter, setGroup]
  )

  const leaves = useMemo(
    () =>
      Object.entries(sliced.map).map(
        ([i, g]) =>
          g.children &&
          Object.entries(g.children).map(([j, entry]) => {
            const group = state.data.groups[i]

            if (!group || !group.children || !group.children[j]) {
              return
            }
            const {
              entity,
              baseValue,
              currency,
              dominance,
              isMobile,
              leafComponent,
              params,
              ...rest
            } = props
            const leaf = group.children[j]
            const key = `${leaf.data.name}${j}`

            const leafProps = {
              params,
              entry,
              entity,
              leaf,
              baseValue,
              isMobile,
              currency,
              addWatchListItems,
              deleteWatchListItems,
              pushToast,
              locked: sliced.locked,
              group: g,
              index: j,
              periods: state.periods,
              isWidget: rest.widget,
              dominance: leaf.data.symbol === 'BTC' ? dominance : undefined,
              watchListObject: state.watchListObject?.data,
            }

            const Component = leafComponent ? leafComponent : Leaf

            return <Component key={key} {...leafProps} />
          })
      ),
    [
      sliced.map,
      sliced.locked,
      state.data,
      props.entity,
      props.baseValue,
      state.periods,
      props.widget,
      state.watchListObject,
      addWatchListItems,
      deleteWatchListItems,
      props.currency,
      pushToast,
      props.isMobile,
      props.dominance,
    ]
  )

  useEffect(() => {
    setHandlers({ onStart: sliced.lock, onEnd: sliced.release })
  }, [sliced.lock, sliced.release])

  return (
    <>
      <div
        className={styles.treeMaps}
        ref={ref}
        id={props.id}
        data-zoom={zoom.transform.k}
        style={{
          width: props.width,
          height: props.height,
          display: props.filteredTree ? undefined : 'none !important',
        }}
      >
        {state.data && (
          <div>
            <canvas ref={canvas} width={props.width} height={props.height} />
            <div
              className={styles.treeMapsRenderer}
              style={{
                width: props.width,
                height: props.height,
                willChange: 'transform',
                transform: cssTransform,
              }}
            >
              <MapZoomControls
                transform={zoom.transform}
                disabled={!Object.keys(sliced.map).length}
                widget={props.widget}
              />
              {Object.entries(sliced.map).map(([i, entry], j) => {
                if (!state.data || !state.data.groups[i]) {
                  return
                }
                const group = state.data.groups[i]
                return (
                  <Group
                    locked={sliced.locked}
                    key={`${group.data.name}${i}`}
                    entry={entry}
                    group={group}
                    transform={
                      sliced.locked ? sliced.transform : zoom.transform
                    }
                    index={i}
                    entity={props.entity}
                    highlight={highlight}
                    onClick={
                      props.onGroupClick ? props.onGroupClick : onGroupClick
                    }
                  >
                    {leaves[j]}
                  </Group>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default TreeMap
